import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const bulkDeletePhoneLines = ( {data} : {data: IBulkDeletePhoneLines | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/------/------`, data);
};

type QueryFnType = typeof bulkDeletePhoneLines;

type UseΒulkDeletePhoneLinesOptions = {
  data: IBulkDeletePhoneLines | {};
  config?: MutationConfig<QueryFnType>;
};

export const useΒulkDeletePhoneLines = ({ config }: UseΒulkDeletePhoneLinesOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην μαζική διαγραφή των τηλεφωνικών γραμμών.`, 500);
            console.error('Couldnt create new phone line', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPhoneLines"])
            addNotification("Η μαζική διαγραφή των τηλεφωνικών γραμμών ήταν επιτυχής.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: bulkDeletePhoneLines,
    })
}